import { createReducer, on } from '@ngrx/store';
import { defaultEntityState } from '@core/state/entities/entity';
import { IMembershipAnnotationStats } from '@core/state/entities/membership-annotation-stats/membership-annotation-stats.entity';
import { projectDetailActions } from '@core/actions/project-detail.actions';
import { stageActions } from '@core/actions/stage.actions';
import {
  mergeEntityState,
  removeEntities,
  removeEntitiesByFilter,
  removeEntitiesWithIds,
} from '@core/state/entities/entity.helpers';
import { entityKey } from '@core/state/entities/entity-name-map';

export const membershipAnnotationStatsEntityReducer = createReducer(
  defaultEntityState<IMembershipAnnotationStats>(),
  on(
    projectDetailActions.screeningSummaryReceived,
    stageActions.receivedFullStats,
    projectDetailActions.fullProjectStatsReceived,
    projectDetailActions.created,
    projectDetailActions.detailLoaded,
    projectDetailActions.projectForInvitationRetrieved,
    projectDetailActions.requestToJoinProjectResponseReceivedAndGranted,
    projectDetailActions.projectUpdated,
    projectDetailActions.projectListingUpdated,
    (state, props) =>
      mergeEntityState(entityKey.membershipAnnotationStats, state, props)
  ),
  on(projectDetailActions.projectDeleted, (state, props) =>
    removeEntitiesByFilter(
      state,
      (projChild) => projChild.projectId === props.projectId
    )
  )
);
